
export default {
  name: 'Label',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      endOfSeriesId: `eos-${this.product.id}-${this.product.variant?.id || 0}`,
      vehiclesId: `veh-${this.product.id}-${this.product.variant?.id || 0}`,
      isMounted: false,
    }
  },
  computed: {
    vehiclesListLabel() {
      return this.$t('components.label.recommendedText')
    },
    vehiclesListTooltip() {
      if (!this.product.vehicles_included || this.product.vehicles_included.length === 0) {
        return this.$t('components.label.recommendedTooltip')
      }

      const allVehicles = this.product.vehicles_included
        .map(v => v.brand ? `${v.brand.name} ${v.name}` : v.name)
        .join(', ')

      return `${this.$t('components.label.compatibleWith')} ${allVehicles}`
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isMounted = true
    })
  },
}
